import { FC } from 'react'
import Tag from './Tag'
import { IconClock, IconRefresh } from '@tabler/icons'
import { Article } from '@/api/types'
import Image from '@/components/Image'
import Link from 'next/link'
import { classNames } from '@/utils'
import { TagPageBase } from 'src/route'
import Author from '@/components/Author'

export type Props = Article & {
  tableOfContents: TableOfContent[]
  readTime: string
}

type TableOfContent = {
  tag: string,
  text: string,
  id: string,
}

const Component: FC<Props> = ({ title, eyeCatching, tableOfContents, body, revisedAt, readTime, tags, summary, author }) => {
  const size = 'w=800&h=450'
  let htmlContent = ''
  body.forEach((b) => {
    htmlContent = htmlContent + b.richContent
    if (b.tableContent !== undefined) {
      htmlContent = htmlContent + `<div class="scroll-table">${b.tableContent}</div>`
    }
  })

  return (
    <>
      <div className="my-5 md:w-full md:text-left">
        <h1 className="text-3xl font-semibold text-primary-900">{title}</h1>
      </div>

      <div className="w-full my-4 flex flex-col md:flex-row md:justify-between">
        <section className="flex gap-2 overflow-hidden">
          {tags.map((tag) => (
            <Link key={tag.id} href={TagPageBase(tag.id, '1')} prefetch={false}>
              <a>
                <Tag name={tag.name} />
              </a>
            </Link>
          ))}
        </section>

        <section className="flex gap-2 text-gray-600">
          <div className="flex gap-1 items-center">
            <IconRefresh width="16" height="16" />
            <p>{revisedAt}</p>
          </div>

          <div className="flex gap-1 items-center">
            <IconClock width="12" height="12" />
            <p>{readTime}</p>
          </div>
        </section>
      </div>

      <div className="rounded-[4px] aspect-video w-full">
        <Image url={eyeCatching.url} size={size} loading="eager" />
      </div>

      <p className="my-4 w-full">{summary}</p>

      {tableOfContents.length !== 0
        ? <>
          <div className='m-article-details w-full'>
            <h2>目次</h2>
          </div>
          <div className="bg-secondary-50 rounded-[4px] w-full p-8 flex flex-col gap-4">
            {tableOfContents.map((t) => {
              return (
                <Link key={t.id} href={'#' + t.id} prefetch={false}>
                  <a className={classNames(
                    'text-secondary-800 list-item list-inside',
                    t.tag === 'H2'
                      ? 'text-lg md:text-2xl'
                      : 'pl-4 text-xs md:text-base'
                  )}>{t.text}</a>
                </Link>
              )
            })}
          </div>
        </>
        : <></>
      }


      <div className="max-w-full m-article-details" dangerouslySetInnerHTML={{ __html: htmlContent }}></div>

      <div className="my-4 w-full">
        <Author {...author} />
      </div>
    </>
  )
}

export default Component
